module.exports = __webpack_public_path__ + "static/media/1.20dad310.jpg";